module.exports = __webpack_public_path__ + "packs/media/images/das_matching_2-7df37bcc38adedd1b86c0ad493ae3357.jpg";